import React from 'react';

import { useTranslation } from 'react-i18next';
import './uploadInfos.css';
import Icon from "../../../ui/icon/icon";
import PlaceholderFile from '../../../../../picture/placeholder-file.png';
import {classnames} from "../../../../../utils/classnames";
import {PlaceholderLine, Placeholder} from "semantic-ui-react";

function UploadInProgress() {
    return (
        <div className={'neo-upload-in-progress'}>
            <Placeholder>
                <PlaceholderLine />
            </Placeholder>
        </div>
    )
}

function UploadStatus({ status = 'uploaded', errors = [] }) {
    const { t } = useTranslation();
    return (
        <div className={classnames('neo-upload-status', `neo-upload-status-${status}`)}>
            {Boolean(errors.length) ? (
                <div className={'neo-upload-status__errors-container'}>
                    {errors.map(error => {
                        return (
                            <div className={'neo-infos-status__error'} key={error}>
                                {error}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div>{t('widget.input.upload.success')}</div>
            )}
        </div>
    )
}

export default function UploadInfos({ status = null, file = null, isImage = false , upload = () => {}, errors = []}) {
    const icon = React.useMemo(() => {
        switch (status) {
            case 'success':
                return 'check';
            case 'error':
                return 'refresh';
            default:
                return null
        }
    },[status])

    const fileSrc = React.useMemo(() => {
        if (file && isImage) {
            return URL.createObjectURL(file);
        }
        return PlaceholderFile
    },[file, isImage])

    const size = React.useCallback(() => {
        if (!file?.size) {
            return '';
        }
        const sizeMo = Math.trunc((file.size / 1000000) * 10) / 10;
        if (sizeMo >= 1) {
            return `(${sizeMo} Mo)`;
        }

        return `(${Math.trunc((file.size / 1000) * 10) / 10} Ko)`;
    }, [file]);

    const fileName = React.useMemo(() => {
        if (!file?.name) {
            return '';
        }
        return `${file.name.substring(file.name.lastIndexOf('/') + 1)} ${size()}`;
    }, [file]);

    if (!file || !status) {
        return null;
    }

    return (
        <div className={classnames('neo-upload-infos', `neo-upload-infos-${status}`)}>
            <div className='neo-upload-infos__image-container'>
                <img alt="event logo" className="neo-upload-infos__image" src={fileSrc}/>
            </div>
            <div className={'neo-upload-infos__content'}>
                <div className={'neo-upload-infos__filename'}>{fileName}</div>
                {status === 'uploading' ? (
                    <UploadInProgress/>
                ) : (
                    <UploadStatus status={status} errors={errors}/>
                )}
            </div>
            {icon && <Icon className={'neo-upload-infos__icon'} name={icon} onClick={status === 'error' ? () => upload(file) : undefined}/>}
        </div>
    );
}
